// src/main.js
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import store from "./store"; // your existing Vuex store
import { useAuthStore } from "./stores/auth"; // new Pinia auth store



import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";

const app = createApp(App);

// install Pinia + your existing Vuex + router
const pinia = createPinia();
app.use(pinia);
app.use(store);
app.use(router);

// initialize auth once, then mount (prevents brief "logged out" flash)
const auth = useAuthStore();
//auth.init().finally(() => {
 // app.mount("#app");
//  });
app.mount("#app");
